module.exports = __webpack_public_path__ + "components/text-summaries/static/rusty@2x-827a8057d95e9484d064399c07821f42.jpg";